import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import axios from "axios";
import * as yup from "yup";
import { toast } from "react-toastify";
import Step1 from "./Steps/Step1";
import { useHistory } from "react-router-dom";

const INITIAL_VALUES = {
  name: "",
  feature_group_id: "",
  amount: 0.00,
  periodicity: "",
  installments: "",
  trial_days: "",
};

export default function AddPlans(props) {
  const history = useHistory();
  const [initialValues, setInitialValues] = useState(INITIAL_VALUES);
  const planId = props.match.params.gateway_id;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInitialValues = async () => {
      if (planId) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/plans/${planId}`);
          setInitialValues(response.data.data);
        } catch (error) {
          console.error("Erro ao buscar os dados do plano", error);
          toast.error("Erro ao carregar dados iniciais.");
        }
      }
      setLoading(false);
    };
    fetchInitialValues();
  }, [planId]);

  async function onCreate(values) {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/plans`, {
      name: values.name,
      feature_group_id: values.feature_group_id,
      amount: values.amount,
      periodicity: values.periodicity,
      installments: values.installments,
      trial_days: values.trial_days,
      is_coupom: false
    });
    return response.data;
  }

  async function onEdit(values) {
    const response = axios.patch(`${process.env.REACT_APP_API_URL}/plans/${planId}`, {
      name: values.name,
      feature_group_id: values.feature_group_id,
      periodicity: values.periodicity,
      installments: values.installments,
      trial_days: values.trial_days,
    });
    return response.data;
  }
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      try {
        if (planId) {
          await onEdit(values)
        } else {
          await onCreate(values)
        }

      } catch (error) {
        toast.error("Ops... tivemos um problema de conexão por isso não conseguimos salvar seu plano.");
        console.error(error);
      } finally {
        setSubmitting(false);
        toast.success("Plano salvo com sucesso!");
        history.push("/plans");
      }
    },
    validationSchema: yup.object().shape({
      name: yup.string().required("O campo nome é obrigatório!"),
      feature_group_id: yup.number().required("O campo grupo de planos é obrigatório!"),
      amount: yup.number().required("O campo valor é obrigatório!"),
      installments: yup.number().required("O campo parcelas é obrigatório!"),
      periodicity: yup.number().required("O campo duração é obrigatório!"),
      trial_days: yup.number().required("O campo dias de trial é obrigatório!"),
    })
  });
  if (loading) {
    return <div>Carregando...</div>;
  }

  return <Step1 step={0} setStep={() => { }} formik={formik} id={planId} />;
}
